var parameterInsert={
    IdEnterprise:'',
    OfficenName:'',
    Adress:'',
    ContactName:'',
    ContactPhone:'',
    ContactEmail:'',
    ContactPosition:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterUpdate={
    IdBranchOffice:'',
    IdEnterprise:'',
    OfficenName:'',
    Adress:'',
    ContactName:'',
    ContactPhone:'',
    ContactEmail:'',
    ContactPosition:'', 
    Active:'1',
    User:'',
    IP:''
} 
var parameterView={ 
    IdEnterprise:'0',  
    OfficenName:'', 
    Active:'2'
} 
export default
{
    parameterInsert,
    parameterUpdate,
    parameterView
}